__turbopack_context__.v({
  "fields": "x2emxq_fields" + " " + __turbopack_context__.i(455038)["fields"],
  "footer": "x2emxq_footer" + " " + __turbopack_context__.i(455038)["footer"],
  "legalText": "x2emxq_legalText",
  "link": "x2emxq_link" + " " + __turbopack_context__.i(455038)["link"],
  "newsletters": "x2emxq_newsletters",
});
